import { h } from 'preact';
export const HardDrive = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "22", y1: "12", x2: "2", y2: "12" }),
        h("path", { d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" }),
        h("line", { x1: "6", y1: "16", x2: "6.01", y2: "16" }),
        h("line", { x1: "10", y1: "16", x2: "10.01", y2: "16" })));
};
//# sourceMappingURL=hard-drive.js.map